export default __webpack_public_path__ + "static/media/down2.96f1ad36.svg";